import React, {useState} from "react";

export default function QuestionRadioInputOption( props ) {
    const option = props.option;

    // Load the icon
    const [iconFile, setIconFile] = useState(null);
    React.useEffect(() => {
        if (option.advanced.icon) {
            setIconFile(option.advanced.icon.preview_url);
        }
    }, [option])

    return (
        <div key={option.id}>
            <label
                className="rounded-tl-md rounded-tr-md relative flex cursor-pointer border p-4 focus:outline-none">
                <input type="radio" id={"option_"+option.id} onChange={props.onChange} name={"answer_"+props.data.id} value={ option.id } defaultChecked={(props.value && option.id === parseInt(props.value))} disabled={props.disabled}
                       className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer text-indigo-600 border-gray-300 focus:ring-indigo-600"
                       aria-labelledby={"option-"+option.id+"-label"} aria-describedby={"option-"+option.id+"-description"}/>
                <span className="mx-3">


                                                        <div>
                                                            { iconFile ? (
                                                                <div className="flex items-start">
                                                                    <div className="flex"> <img src={iconFile} className="max-h-[24px] mr-2" alt={option.answer}/></div>
                                                                    <span id={"option-"+option.id+"-description"} className="flex-1">
                                                                  { option.answer }
                                                              </span>
                                                                </div> ) : (
                                                                <span id={"option-"+option.id+"-description"}>
                                                                  { option.answer }
                                                              </span>
                                                            ) }


                                                        </div>


                                  </span>
            </label>
        </div>
    );
}